export default __webpack_public_path__ + "static/media/UTPL_Annual_Return_2024.75d770af.pdf";